<template>
  <div class="match-detail-page page-max-width">
    <MatchDetailHeroSection :hero-data="matchDetailHeroData" />
    <MatchDetailScheduleSection :schedule-data="matchDetailScheduleData" :schedule-list="matchDetailScheduleList" />
    <MatchDetailRulesSection />
    <MatchPageFooter />
  </div>
</template>

<script>
import MatchDetailHeroSection from '@/components/match/detail/MatchDetailHeroSection.vue'
import MatchDetailScheduleSection from '@/components/match/detail/MatchDetailScheduleSection.vue'
import MatchDetailRulesSection from '@/components/match/detail/MatchDetailRulesSection.vue'
import MatchPageFooter from '@/components/match/common/MatchPageFooter.vue'
import { matchDetailHeroData, matchDetailScheduleData, matchDetailScheduleList } from '@/data/match/matchDetail'

export default {
  name: 'MatchDetail',
  components: { MatchDetailHeroSection, MatchDetailScheduleSection, MatchDetailRulesSection, MatchPageFooter },
  data() {
    return { matchDetailHeroData, matchDetailScheduleData, matchDetailScheduleList }
  },
}
</script>

<style lang="scss" scoped>
.match-detail-page {
  min-height: 100vh;
  overflow-x: hidden;
  background: #d6dbe1;

  @media (max-width: 750px) {
    background: #e7eaed url('@/assets/image/match/pc/match/1.jpg') center top / 100% auto no-repeat;
  }
}
</style>
